/*
Description
    Thin API wrapper for Inshell Product (Project 2116, Almondco Intake
    Masters Migration - #76589/#76617). Feature-scoped, matching the sibling
    almondco-scheme-price.service.js/almondco-grower-syndicate-split.service.js
    convention rather than folding into the general IntakeSettingService.

History
    02Sep2026 (SS)
        - #76589: 2116 - UI - Inshell Product List and filter panel
        - #76617: 2116 - UI - Inshell Product split-view detail panel
          (Review/Edit modes, eligible-product grid)

(c) Copyright Graycorp Pty Ltd (ABN 12 082 807 761). All Rights Reserved.
*/
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const AlmondcoInshellProductService = {
  // §5/§9: AlmondcoInshellVarietySummary, filtered to a single row's
  // InshellVarietyCode - resolves the identity header (Inshell Code/Name,
  // Kernel Variety Code/Name, Configured Product Count) on baseView.id
  // change, whether that's a row click or a direct/bookmarked URL. No
  // separate RecordId indirection needed - InshellVarietyCode is already the
  // routable :id (§6).
  async getInshellVarietySummary(inshellVarietyCode) {
    var url = `api/AlmondcoInshellVarietySummary?$filter=InshellVarietyCode eq '${inshellVarietyCode}'`;
    return await ApiService.get(url);
  },

  // §5/§9: AlmondcoInshellEligibleProduct, filtered to the opened variety -
  // the derived detail grid's own load call. No GetByID exists (AD, §5) -
  // $filter on InshellVarietyCode is the only way to key one on, matching
  // Scheme Prices'/Grower Pool Splits' own $filter-on-open precedent.
  async getEligibleProducts(inshellVarietyCode) {
    var url = `api/AlmondcoInshellEligibleProduct?$filter=InshellVarietyCode eq '${inshellVarietyCode}'`;
    return await ApiService.get(url);
  },

  // §5: POST api/Save_AlmondcoInshellProduct - full update/insert/delete
  // reconciliation of the opened variety's packaging configuration.
  async saveInshellProduct(payload) {
    return await ApiService.post("api/Save_AlmondcoInshellProduct", payload);
  },
};

export { AlmondcoInshellProductService };
